import { ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { useBuyer } from "@/contexts/BuyerContext";
import { useAuth } from "@/contexts/AuthContext";
import SellerUpgradeDialog from "./SellerUpgradeDialog";

interface SellerRestrictedPageProps {
  children: ReactNode;
  featureName?: string;
}

const SellerRestrictedPage = ({ children, featureName = "feature" }: SellerRestrictedPageProps) => {
  const { subscriptionStatus } = useSubscription();
  const { isBuyer } = useBuyer();
  const { profile } = useAuth();
  
  // Only show restriction for sellers (not buyers, has seller profile) with expired status
  // Don't restrict sponsored users
  const isSeller = !isBuyer && profile;
  const isSellerExpired = isSeller && subscriptionStatus === 'expired';
  
  if (isSellerExpired) {
    return (
      <div className="container mx-auto py-6">
        <Card>
          <CardContent className="flex items-center justify-center py-12">
            <div className="text-center max-w-md">
              <div className="w-16 h-16 bg-godyspo-gold/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 bg-godyspo-gold rounded-full"></div>
              </div>
              <h3 className="text-xl font-semibold mb-2">Upgrade Required</h3>
              <p className="text-muted-foreground mb-6">
                Your free trial has ended. Upgrade to the Shark Plan to access {featureName} and continue managing your real estate deals.
              </p>
              <Button
                onClick={() => window.location.href = '/seller/upgrade'}
                className="bg-godyspo-gold text-black hover:bg-godyspo-gold/90"
                size="lg"
              >
                Upgrade Now
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
};

export default SellerRestrictedPage;